module.exports = __webpack_public_path__ + "static/media/logo.d4be84cf.png";